import { axiosInstance } from "./axios";

// ==================== Monitoring Settings ====================

export const upsertMonitoringSetting = async (data: {
  project_id: string;
  team_id: string;
  item_id?: string;
  item_type?: string;
  is_enabled: boolean;
  frequency: string;
  custom_interval_hours?: number;
}) => {
  return axiosInstance.put("project/monitoring", data);
};

export const isMonitoringActive = async (projectId: string) => {
  return axiosInstance.get(`project/monitoring/active/${projectId}`);
};

export const getAllMonitoringSettings = async (projectId: string) => {
  return axiosInstance.get(`project/monitoring/all/${projectId}`);
};

export const getMonitoringSetting = async (
  projectId: string,
  itemId?: string
) => {
  const params = itemId ? `?item_id=${itemId}` : "";
  return axiosInstance.get(`project/monitoring/${projectId}${params}`);
};

// ==================== Notifications ====================

export const getNotifications = async (
  teamId: string,
  page = 1,
  limit = 20
) => {
  return axiosInstance.get(
    `project/notifications?team_id=${teamId}&page=${page}&limit=${limit}`
  );
};

export const getUnreadNotificationCount = async (teamId: string) => {
  return axiosInstance.get(
    `project/notifications/unread-count?team_id=${teamId}`
  );
};

export const markNotificationAsRead = async (notificationId: string) => {
  return axiosInstance.put(`project/notifications/${notificationId}/read`);
};

export const markAllNotificationsAsRead = async (teamId: string) => {
  return axiosInstance.put(
    `project/notifications/read-all?team_id=${teamId}`
  );
};

export const deleteNotification = async (notificationId: string) => {
  return axiosInstance.delete(`project/notifications/${notificationId}`);
};

export const deleteAllNotifications = async (teamId: string) => {
  return axiosInstance.delete(`project/notifications/all?team_id=${teamId}`);
};

export const getNotificationCountsByProject = async (teamId: string) => {
  return axiosInstance.get(
    `project/notifications/counts-by-project?team_id=${teamId}`
  );
};

export const getUpdatedItems = async (projectId: string) => {
  return axiosInstance.get(
    `project/notifications/updated-items/${projectId}`
  );
};
